import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Notification from 'utils/Notifications'
import {
  getContingent,
  downloadContingent,
} from 'service/ReportsService'
import {
  PageHeader,
  UnvButton,
  Skeleton,
  ErrorState,
  EmptyState,
  Card,
} from 'components'

import ContingentTables from './components/ContingentTables/ContingentTables'
import DateFilter from './components/DateFilter/DateFilter'
import styles from './ContingentReportPage.module.scss'

const todayISO = () => new Date().toISOString().slice(0, 10)

const ContingentReportPage = () => {
  const { t } = useTranslation('common')
  const [date, setDate] = useState(todayISO())
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' })

  const load = async () => {
    setLoading(true)
    setError(false)
    try {
      const res = await getContingent({ date })
      setData(res.data || null)
    } catch {
      setError(true)
      setData(null)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { load() }, [date])

  const handleDownload = async (fmt) => {
    try {
      await downloadContingent({ date }, fmt)
      setNotify({ isOpen: true, message: t('reports.file_downloaded'), type: 'success', sound: 'success' })
    } catch {
      setNotify({ isOpen: true, message: t('reports.file_download_failed'), type: 'error', sound: 'error' })
    }
  }

  return (
    <div className={styles.page}>
      <PageHeader
        title={t('reports.contingent_title')}
        subtitle={t('reports.contingent_subtitle')}
        actions={
          <>
            <UnvButton variant="secondary" iconLeft="download" onClick={() => handleDownload('xlsx')}>
              XLSX
            </UnvButton>
            <UnvButton variant="secondary" iconLeft="download" onClick={() => handleDownload('csv')}>
              CSV
            </UnvButton>
          </>
        }
      />

      <Card className={styles.toolbar}>
        <DateFilter value={date} onChange={setDate} />
        <UnvButton variant="primary" iconLeft="refresh" onClick={load}>
          {t('reports.load_btn')}
        </UnvButton>
      </Card>

      <Card className={styles.content}>
        {loading ? (
          <Skeleton variant="table" rows={8} cols={5} />
        ) : error ? (
          <ErrorState title={t('reports.contingent_load_failed')} onRetry={load} />
        ) : !data ? (
          <EmptyState iconName="folder" title={t('reports.contingent_load_failed')} />
        ) : (
          <ContingentTables data={data} />
        )}
      </Card>

      <Notification notify={notify} setNotify={setNotify} />
    </div>
  )
}

export default ContingentReportPage
